<div
  class="rounded-2xl bg-white p-10 shadow-sm text-center border-t-4 border-t-green-500"
>
  <div class="text-4xl mb-4">✅</div>
  <h2 class="text-xl font-bold text-slate-900">Already Submitted</h2>
  <p class="text-slate-500 mt-2">
    You have already completed this survey. Thank you!
  </p>
</div>
